import {Injectable, TemplateRef} from '@angular/core';
import {DynamicFieldComponent} from '../../dynamic-field/dynamic-field-component';

@Injectable()
export class CustomFieldService {

    private templates: Map<string, TemplateRef<DynamicFieldComponent>> = new Map();

    public getTemplate(name: string): TemplateRef<DynamicFieldComponent> {
        return this.templates.get(name);
    }

    public getTemplates(): Map<string, TemplateRef<DynamicFieldComponent>> {
        return this.templates;
    }

    public setTemplates(templates: Map<string, TemplateRef<DynamicFieldComponent>>) {
        this.templates = templates;
    }
}
